// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  width: 100%;
  height: 100%;
}

@media (min-width: 1024px) {
  .hero {
    background: url("https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/BgCotizadorDesktop.jpg")
      no-repeat center center;
    background-size: cover;
  }
}

@media (max-width: 1023px) {
  .hero {
    background: url("https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/BgCotizadorTablet.jpg")
      no-repeat bottom center;
    background-size: cover;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE;6BACyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE;6BACyB;IACzB,sBAAsB;EACxB;AACF","sourcesContent":[".hero {\n  width: 100%;\n  height: 100%;\n}\n\n@media (min-width: 1024px) {\n  .hero {\n    background: url(\"https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/BgCotizadorDesktop.jpg\")\n      no-repeat center center;\n    background-size: cover;\n  }\n}\n\n@media (max-width: 1023px) {\n  .hero {\n    background: url(\"https://assistcdn.s3.us-west-1.amazonaws.com/assets/img/home/BgCotizadorTablet.jpg\")\n      no-repeat bottom center;\n    background-size: cover;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
